import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CreditCardIcon as WalletBreakdownIcon,
  LockClosedIcon as LockedBreakdownIcon,
  GiftIcon as UnclaimedBreakdownIcon,
  TrendingUpIcon as PortfolioIcon,
} from '@heroicons/react/outline';

import { Card } from 'components/Card';
import { BalanceChart, PortfolioCards, PortfolioTable } from 'components/Portfolio';
import { Section } from 'components/Section';
import { usePortfolio } from 'contexts';
import WalletBreakdownSection from 'components/Section/WalletBreakdownSection';

const Portfolio = () => {
  const { t } = useTranslation();
  const {
    walletBalance,
    walletBalanceUsd,
    walletBalanceTotalUsd,
    lockedBalance,
    lockedBalanceUsd,
    lockedBalanceTotalUsd,
    unclaimedBalance,
    unclaimedBalanceUsd,
    unclaimedBalanceTotalUsd,
  } = usePortfolio();

  return (
    <div className="container space-y-10">
      <Section className="space-y-4" title={t('portfolio.title')} icon={PortfolioIcon}>
        <PortfolioCards />
      </Section>
      <Section className="space-y-4" title={t('portfolio.overview_title')} icon={PortfolioIcon}>
        <Card
          title={t('portfolio.balance_chart.title')}
          body={
            <div className="p-3">
              <BalanceChart />
            </div>
          }
        />
        <Card
          className="pb-4"
          body={
            <div className="p-3">
              <PortfolioTable />
            </div>
          }
        />
      </Section>
      {walletBalanceTotalUsd > 0 && (
        <WalletBreakdownSection
          title={t('portfolio.wallet_breakdown.title')}
          icon={WalletBreakdownIcon}
          assetsTitle={t('portfolio.wallet_breakdown.assets_title')}
          balance={walletBalance}
          balanceUsd={walletBalanceUsd}
          balanceTotalUsd={walletBalanceTotalUsd}
        />
      )}
      {lockedBalanceTotalUsd > 0 && (
        <WalletBreakdownSection
          title={t('portfolio.locked_breakdown.title')}
          icon={LockedBreakdownIcon}
          assetsTitle={t('portfolio.locked_breakdown.assets_title')}
          balance={lockedBalance}
          balanceUsd={lockedBalanceUsd}
          balanceTotalUsd={lockedBalanceTotalUsd}
        />
      )}
      {unclaimedBalanceTotalUsd > 0 && (
        <WalletBreakdownSection
          title={t('portfolio.unclaimed_breakdown.title')}
          icon={UnclaimedBreakdownIcon}
          assetsTitle={t('portfolio.unclaimed_breakdown.assets_title')}
          balance={unclaimedBalance}
          balanceUsd={unclaimedBalanceUsd}
          balanceTotalUsd={unclaimedBalanceTotalUsd}
        />
      )}
    </div>
  );
};

export default Portfolio;
